'use client';

import { ImageIcon, ArrowUpRight } from 'lucide-react';

// Striped media placeholder (system rule: never hand-draw imagery). Theme-aware
// via the --ph-* CSS vars defined in theme-tokens.css. Used for photo posts and
// as the video frame's fallback background.
export default function MediaPlaceholder({
  label,
  icon,
  className,
}: {
  label: string;
  icon?: 'image' | 'video';
  className?: string;
}) {
  return (
    <div
      className={className}
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'repeating-linear-gradient(135deg, var(--ph-bg) 0 11px, var(--ph-stripe) 11px 22px)',
      }}
      aria-hidden
    >
      <span
        className="font-mono"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 7,
          color: 'var(--ph-text)',
          fontSize: 10.5,
          fontWeight: 600,
          letterSpacing: '.06em',
          textTransform: 'uppercase',
          background: 'color-mix(in oklab, var(--ph-bg) 80%, transparent)',
          padding: '4px 9px',
          borderRadius: 'var(--r-sm, 6px)',
        }}
      >
        {icon === 'image' && <ImageIcon className="w-3.5 h-3.5" strokeWidth={1.75} />}
        {icon === 'video' && <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.75} />}
        {label}
      </span>
    </div>
  );
}
